import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { rhythm/*, scale */} from "../utils/typography"

import Search from "../components/search"
import StripeSpacer from "../components/stripe-spacer"

const Logo = styled.h1`
  font-family: Montserrat, sans-serif;
  margin: 0;
  transition: .3s;
  position: relative;
  @media(max-width: 600px) {
    margin-bottom: 24px!important;
  }
  &:hover {
    box-shadow: 0px 8px 0px;
    &:after {
      // transition: .3s;
      width: 8px;
      // color: orange;
      box-shadow: 0px 8px 0px;
      transform: translateX(0px)
    }
  }
  &:after {
    content: '';
    display: inline-block;
    position: absolute;
    right: -12px;
    width: 0px;
    height: 100%;
    box-shadow: 0px 0px 0px;
    transition: .3s;
    transform: translateX(24px)
  }
`

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media(max-width: 600px) {
    display: block;
  }
`

const BackToTop = styled.button`
  border: none;
  box-shadow: inset 0 0 0 8px rgba(0,0,0,0.1);
  margin: 80px auto;
  display: block;
  cursor: pointer;
  font-size: 15px;
  padding: 8px 16px;
  transition: 0.3s;
  &:hover {
    box-shadow: inset 0 0 12px 4px rgba(0,0,0,0.4);
  }
`

const Layout = ({ location, title, children }) => {
  // const rootPath = `${__PATH_PREFIX__}/`
  const [tLeft, tRight] = title.split(' ')
  return (
    <div
      style={{
        marginLeft: `auto`,
        marginRight: `auto`,
        maxWidth: '960px',
        padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
      }}
    >
      <Header>
        <Logo
          className="site-title"
          style={{
            fontFamily: `Montserrat, sans-serif`,
            margin: 0,
          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              color: `inherit`,
              // textDecoration: 'none'
            }}
            to={`/`}
          >
            {tLeft} <small style={{ fontSize: '13px', fontWeight: 'normal' }}>{tRight}</small>
          </Link>
        </Logo>
        <Search />
      </Header>
      <StripeSpacer />
      <main>{children}</main>
      <StripeSpacer />
      <BackToTop
        onClick={() => window.scrollTo(0,0)}
      >
        BACK TO TOP
      </BackToTop>
      <footer
        style={{
          fontFamily: 'Montserrat, sans-serif',
        }}
      >
        © {new Date().getFullYear()}, <span style={{ fontWeight: 'bold' }}>siomin_</span>
        {` `}
        {/* <a href="https://www.gatsbyjs.org">Gatsby</a> */}
      </footer>
    </div>
  )
}

export default Layout
